import React from 'react'
import './not-found-page.css'

const NotFoundPage = () => {
  return (
    <div className="container-404">
       <h1>Error 404</h1> 
    </div>
  )
}

export default NotFoundPage